import React from 'react';
import { connect } from 'react-redux';

const PlaceholderImage = (props) => {
    const { text } = props;
    // const { backgroundColor } = props.themeColors;
    // const splitName = (text ?? "AT").toUpperCase().split(" ");
    // const initials = splitName.length > 1 ? splitName[0][0] + splitName[1][0] : splitName[0][0] + splitName[0][1];
    // return (
    //     <span style={{ color: backgroundColor, fontSize: '14px' }}><b>{initials}</b></span>
    // );
    const placeholder = `https://avatars.dicebear.com/api/identicon/${text}.svg?backgroundColor=%23ffffff`
    return (
        <img src={placeholder} alt="user" className="avatar-square" />
    );

};

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
    }
}

export default connect(mapStateToProps)(PlaceholderImage);